import {
  Box,
  Container,
  Link,
  Theme,
  Typography,
  useMediaQuery,
} from "@mui/material";

import { CUSTOMER_SUPPORT_EMAIL } from "helpers/constants";
import { colors } from "theme";

export const MoreQuestions = () => {
  const xs = useMediaQuery((theme: Theme) => theme.breakpoints.only("xs"));

  return (
    <Box
      component="section"
      paddingTop={{ xs: 3, sm: 10 }}
      paddingBottom={{ xs: 4, sm: 12 }}
      bgcolor={colors.white}
      position="relative"
      overflow="hidden"
    >
      <Container>
        <Box position="relative">
          <Typography component="h2">
            <Box
              component="span"
              display="block"
              textAlign="center"
              mb={4}
              fontSize={xs ? 21 : 32}
              lineHeight={xs ? "30.62px" : "46.66px"}
              fontWeight={600}
              letterSpacing={0.5}
            >
              Have more questions?
            </Box>
          </Typography>
          <Typography align="center">
            Click to{" "}
            <Link
              href={`mailto:${CUSTOMER_SUPPORT_EMAIL}`}
              underline="always"
              color="secondary"
              target="_blank"
            >
              Contact Technical Support.
            </Link>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};
